export default class CashbookTaxRatesResponseEntry {
  ART!: number;

  STEUERSATZ!: number;
}
